var _rect, _rect2, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 501,
    height: 65,
    viewBox: "0 0 501 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 10,
    width: 419,
    height: 8,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 10,
    width: 205,
    height: 8,
    fill: "#1DB954"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2835_855)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43,
    width: 32,
    height: 32,
    rx: 3,
    fill: "#1DB954"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7668 16.7171L56.4168 22.1671L66.4918 10.3838",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2835_855)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256,
    width: 32,
    height: 32,
    rx: 3,
    fill: "#1DB954"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.767 16.7171L269.417 22.1671L279.492 10.3838",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2835_855)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 469,
    width: 32,
    height: 32,
    rx: 3,
    fill: "#CDCDCD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2835_855"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2835_855"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 256,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2835_855"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 469,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressBar);
export default __webpack_public_path__ + "static/media/progress-bar.c995b9366c7857a4f920fc038c7b147b.svg";
export { ForwardRef as ReactComponent };